import {
    Alert,
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import React from 'react';
import { ModalProps } from '../../../types/modal';
import {
    Channel,
    MessageList,
    Window,
    useChannelStateContext,
} from 'stream-chat-react';
import { Close, MoreHoriz } from '@mui/icons-material';

const PinnedMessages = ({ open, onClose }: ModalProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const { pinnedMessages } = useChannelStateContext();

    pinnedMessages?.sort((a, b) => {
        const aTime = a.created_at ? new Date(a.created_at).getTime() : 0;
        const bTime = b.created_at ? new Date(b.created_at).getTime() : 0;
        return aTime - bTime;
    });

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth='sm'
            fullWidth
            fullScreen={isMobile}
        >
            <DialogTitle>
                Pinned Messages
                <IconButton
                    aria-label='close'
                    onClick={onClose}
                    size='small'
                    sx={{ color: 'text.primary' }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
                    <Alert severity='info'>
                        To pin a message in this chat, first hover over the
                        message, click the three dots (
                        <MoreHoriz fontSize='small' />) and select 'Pin'.
                    </Alert>
                </Box>
                {/* Channel provides styling */}
                <Channel>
                    <Window>
                        <MessageList
                            messages={pinnedMessages}
                            messageActions={[]}
                        />
                    </Window>
                </Channel>
            </DialogContent>
        </Dialog>
    );
};

export default PinnedMessages;
